import { render, staticRenderFns } from "./GameIdPicker.vue?vue&type=template&id=2061d30b"
import script from "./GameIdPicker.vue?vue&type=script&lang=js"
export * from "./GameIdPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports